import React, { useState, useEffect } from 'react';
import { SearchableSingleSelect } from '@ibinder/common-frontend';
import styled from 'styled-components';

const Container = styled.div`
  animation: identifier 350ms;
  margin-bottom: 1rem;
  @keyframes identifier {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 80px;
    }
  }
`;

const SearchableDropDown = ({ label, data, loading, setSelectedIndex }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  function changeActiveItem(index) {
    setActiveIndex(index);
    setSelectedIndex(index);
  }

  useEffect(() => changeActiveItem(null), [data]);

  return (
    <Container>
      <SearchableSingleSelect
        data-test="field-binder"
        activeKey={activeIndex}
        changeActiveItem={changeActiveItem}
        data={
          data?.length > 0
            ? data.map((item, i) => ({
                Value: item.name,
                Key: i
              }))
            : []
        }
        loading={loading}
        label={label}
        dropdownText="Select.."
        searchPlaceholderText={`Search ${label}`}
        required={true}
      />
    </Container>
  );
};

export default SearchableDropDown;
